import { useMutation, useQueryClient } from 'react-query'
import { fetchWrapper } from 'src/utils/fetchWrapper'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'

export function useUpdateFlagged(workOrderID: number) {
  const API_ENDPOINT = `/workorders/${workOrderID}/update`
  const queryClient = useQueryClient()
  const { t } = useTranslation()

  const updateFlagged = async (data: any) => {
    try {
      const response = await fetchWrapper({
        method: 'PUT',
        url: API_ENDPOINT,
        body: data,
      })
      toast.success(t('Work order flagged successfully'))
      return response
    } catch (error) {
      console.error('API request failed:', error)
      toast.error(t('Failed to flagged work order'))
      throw error
    }
  }

  return useMutation('workOrderDetails', updateFlagged, {
    onSuccess: () => {
      queryClient.invalidateQueries('workOrderDetails')
    },
  })
}
